import type { RunStatus } from "src/queries/pipelines/pipelineRuns.types";

export const RUN_STATUSES: Record<string, RunStatus> = {
  SUCCESS: "success",
  COMPLETED: "completed",
  COMPLETED_WITH_ERRORS: "completed_with_errors",
  FAILED_WITH_ERRORS: "failed_with_errors",
  COMPLETED_WITH_RETRIES: "completed_with_retries",
  WITH_RETRIES: "with_retries", // mandatory alias due to how the data is returned from the API
  FAILED: "failed",
  ERROR: "error",
  PREEMPTED: "preempted",
  RUNNING: "running",
  DISABLED: "disabled",
  UNKNOWN: "unknown",
} as const;

export const TOOLTIP_DELAY = 300;
